import React from 'react'
import { FormStainGrams } from './FormStainGrams';
import { Dialog } from 'primereact/dialog';
import { Button } from 'reactstrap';


export const ModalStainGrams = (props) => {

    const {
        modal, tittle, toggle, method,
        name,
        handleInputChange, loading, closeDialogG,
        saveCreate, saveUpdateStain, saveDeleteStain
    } = props;

    return (
        <Dialog
            visible={modal}
            onHide={closeDialogG}
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icofont icofont-ui-clip-board f-20"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {tittle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v3`}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveCreate}
                        >
                            {
                                loading ? "Creando...." : "Crear"
                            }
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveUpdateStain}
                        >
                            {
                                loading ? "Actualizando...." : "Actualizar"
                            }
                        </Button>
                    }
                    <Button
                        size="sm"
                        color='danger'
                        type="button"
                        onClick={closeDialogG}>
                        Cancelar
                    </Button>
                </>
            }
        >
            {
                method === "create"
                    ? <FormStainGrams
                        button={"Crear"}
                        {...{ closeDialogG, loading, name, handleInputChange, methodAction: saveCreate }}
                    />
                    : (method === "update")
                        ?
                        <FormStainGrams
                            button={"Actualizar"}
                            {...{ closeDialogG, loading, name, handleInputChange, methodAction: saveUpdateStain }} />
                        :
                        null
            }
        </Dialog>
    )
}
